import { render, staticRenderFns } from "./EventsWidget.vue?vue&type=template&id=599bfd76&"
import script from "./EventsWidget.vue?vue&type=script&lang=ts&"
export * from "./EventsWidget.vue?vue&type=script&lang=ts&"
import style0 from "./EventsWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports